import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeViewer, nextImage, previousImage, setImages } from './slide';
// @ts-ignore
import ImgsViewer from "react-images-viewer";
const ChatImagesViewer = ({ messages }) => {
    const { images, currentImage, isOpen } = useSelector((state) => state['features/images-viewer']);
    const dispatch = useDispatch();
    useEffect(() => {
        if (messages) {
            let rawImages = [];
            try {
                rawImages = messages
                    .flatMap(message => message.attachments)
                    .filter(attachment => attachment?.type?.includes('image'))
                    .map(attachment => ({ src: attachment?.src || attachment?.url || attachment?.getUrl }));
            }
            catch (e) {
                console.error(e);
            }
            dispatch(setImages(rawImages));
        }
        return () => {
            dispatch(setImages([]));
        };
    }, [messages, dispatch]);
    return (React.createElement(ImgsViewer, { imgs: images, currImg: currentImage, isOpen: isOpen, onClickPrev: () => dispatch(previousImage()), onClickNext: () => dispatch(nextImage()), onClose: () => dispatch(closeViewer()) }));
};
export default ChatImagesViewer;
